import {
  loadProductsRegistry,
  loadProducts,
  CARD_PRODUCT,
  selectProduct,
} from '@americanexpress/product-ducks';

const loadProductData = ({ dispatch }) => async (
  nextState,
  replace,
  callback
) => {
  try {
    await dispatch(loadProductsRegistry({ forceFetch: true }));
    const products = await dispatch(loadProducts({ forceFetch: true }));
    // istanbul ignore else: no else case
    if (products[CARD_PRODUCT]) {
      const cardProduct = products[CARD_PRODUCT].productsOrder[0];

      if (cardProduct) {
        dispatch(selectProduct(cardProduct));
      }
    }
  } catch (error) {
    // deliberately ignoring error for now because it's ok not to have products
  }
  return callback();
};

export default loadProductData;
